import React, { useState, useContext, createContext } from "react";
import { PaymentServices } from "../services/PaymentServices";

// ** Utils Imports
const paymentContext = createContext();

export function ProviderPayment({ children }) {
  const payment = useProviderPayment();
  return (
    <paymentContext.Provider value={payment}>
      {children}
    </paymentContext.Provider>
  );
}

export const usePayment = () => {
  return useContext(paymentContext);
};

function useProviderPayment() {
  // ** State
  const [isOpenPymentForm, setIsOpenPymentForm] = useState(false);
  const [htmlPymentForm, setHtmlPymentForm] = useState(null);
  const [isLoadingHtmlPymentForm, setIsLoadingHtmlPymentForm] = useState(true);

  const getFormPayment = async (orderID) => {
    PaymentServices.get();
    // if (orderID) {
    //     setIsOpenPymentForm(true)
    //     setIsLoadingHtmlPymentForm(true);
    //     console.log('=======================Start Loadin form Payment')
    //   axios
    //     .get(`https://food.akwade.net/order_stripe/${orderID}`)
    //     .then((response) => {
    //         console.log('=======================response', response)
    //     })
    //     .catch((error) => {
    //         console.log('=======================error', error)
    //     })
    //     .finally(() => {
    //         setIsLoadingHtmlPymentForm(false)
    //     });
    // }
  };

  // Return State
  return {
    isOpenPymentForm,
    htmlPymentForm,
    isLoadingHtmlPymentForm,
    setIsOpenPymentForm,
    setHtmlPymentForm,
    setIsLoadingHtmlPymentForm,
    getFormPayment
  };
}
